import { Component } from '@angular/core';
import { TransferHttpService, TenantConfig, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';

import { PermissionsService } from '../../../services/permissions/permissions.service';
import { map, switchMap } from 'rxjs/operators';
import { HrEmployeeJobAssignments, HrEmployees } from '../../../../models';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';

@Component({
  selector: 'viewEmployees',
  templateUrl: './viewEmployees.component.html',
  providers: [MainGridService]
})

export class ViewEmployeesComponent {

  tablePermissions: AimsCommonTablePermissions = {
    create: false, // Set below in constructor
    update: false, // Set below in constructor
    delete: false,
  };
  initialTableElement;

  viewEmployeeHeader: AimsCommonTableHeader[] = [
    { key: 'details', label: 'Details', type: 'button', prefix: '/hr/employee/', linkId: 'employeeId', filter: false },
    { key: 'button', label: '', type: 'dynamic', filter: false, hidden: !this.transferHttp.tenantConfig.hr.tenantUsesPsc},
    { key: 'fullName', label: 'Employee', type: 'string' },
    { key: 'employeeNumber', label: 'Emp #', type: 'string', width: 100 },
    { key: 'jobTitle', label: 'Job Title', type: 'string', filterType: 'dynamic' },
    { key: 'assignmentDescription', label: 'Assignment', type: 'string', filterType: 'dynamic' },
    { key: 'employeeStatus', label: 'Employee Status', type: 'string', filterType: 'dynamic' },
    { key: 'employmentTypeCode', label: 'Employment Type', type: 'string', filterType: 'dynamic' },
    { key: 'employmentStatusCode', label: 'Employment Status', type: 'string', filterType: 'dynamic' },
    { key: 'unionAffiliationCode', label: 'Union', type: 'string', filterType: 'dynamic'  },
  ];

  constructor(
    public mainGridService: MainGridService<any>,
    private transferHttp: TransferHttpService,
    private router: Router,
    public permissions: PermissionsService) { }

  activeStatusIds = this.transferHttp.tenantConfig.hr.activeStatusIds;

  //EmploymentStatusId
  PASS: number = 3;

  //EmployeeStatusId
  TERMINATE: number = 9;

  employee: number;
  routedFrom = "viewEmployees";

  includeExEmployees: BehaviorSubject<boolean> = new BehaviorSubject(true);

  public emps = this.includeExEmployees.pipe(
    switchMap(isActive => this.transferHttp.getHot(`hr/GetAllEmployeesForViewEmployees`).pipe(
      map((empsArr: Array<HrEmployees>) =>
        empsArr.filter(emp => (isActive) ? this.activeStatusIds.indexOf(emp.employmentStatusId) != -1 : true))
    )));

  //DropDown Values
  jobTitleValues = this.transferHttp.getSingle(`Common/GetAllJobTitlesForDropdown`);
  employeeJobAssignmentValues = this.transferHttp.getSingle(`Common/GetAllEmployeeJobAssignmentsForDropDown`);

  employeeStatusValues = this.transferHttp.getSingle(`hr/GetEmployeeStatus`);
  employmentTypeValues = this.transferHttp.getSingle(`hr/GetEmploymentType`)
  employmentStatusValues = this.transferHttp.getSingle(`hr/GetEmploymentStatus`);
  unionValues = this.transferHttp.getSingle(`hr/GetUnionAffiliation`);


  ngOnInit(): void {
  };
}
